import React, { FC } from "react";

import { RadioButtonProps } from "./modules";
import { RadioButtonStyled } from "./styles";

const RadioButton: FC<RadioButtonProps> = ({
  id,
  label,
  checked,
  onChange,
  disabled,
}) => {
  return (
    <RadioButtonStyled disabled={!!disabled} checked={checked}>
      <input
        id={id}
        type="radio"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      {label && <label htmlFor={id}>{label}</label>}
    </RadioButtonStyled>
  );
};

export default RadioButton;
